import React from "react";
import module_style from "../style.module.css";
import { MoreActions } from "ui/modules/MoreActions";
import EditIcon from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Dots from "@material-ui/icons/DragIndicator";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PointersCard from "./PointersCard";
import { handleOnDragEnd } from "./common";

const AdditionalPointersList = ({
  data,
  set_show_modal,
  set_data,
  set_selected_id,
  handleDelete,
  handleEdit,
  disableAllEdits,
}) => {
  const options = [
    {
      title: "Edit",
      icon: <EditIcon />,
      handleClick: handleEdit ? () => handleEdit() : () => set_show_modal(true),
    },
    { title: "Delete", icon: <Delete />, handleClick: () => handleDelete() },
  ];

  const handleOnDrag = (result) => handleOnDragEnd(result, set_data, data);

  return (
    <DragDropContext onDragEnd={handleOnDrag}>
      <Droppable
        droppableId="additional_pointers"
        type="ADDITIONAL_POINTERS"
        mode="standard"
      >
        {(provided) => (
          <div ref={provided.innerRef}>
            {data
              ?.filter((item) => !item.draft)
              .map((item, index) => (
                <Draggable
                  key={`additional_pointers-${item?.id}`}
                  draggableId={`additional_pointers-${item?.id}`}
                  index={index}
                >
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.draggableProps}>
                      <div className={`mt-2 mb-2 position-relative`}>
                        {provided && (
                          <div
                            className={`mr-1 ${module_style.drag_svg}`}
                            style={{ cursor: "grab" }}
                            {...provided.dragHandleProps}
                          >
                            <Dots />
                          </div>
                        )}
                        <div className={`${module_style.dots_svg}`}>
                          {disableAllEdits ? null : (
                            <div onClick={() => set_selected_id(item.id)}>
                              <MoreActions
                                options={options}
                                shift={{ x: 45, y: 70 }}
                              />
                            </div>
                          )}
                        </div>
                        <PointersCard
                          imgSrc={item?.additional_pointers_cover}
                          title={item?.title}
                          description={item?.description}
                        />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default AdditionalPointersList;
